export default __webpack_public_path__ + "static/media/logoLine.d382a79f.webp";